import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";
import { Button, SaveButton } from "../../../components/Buttons";

export const HandoverFrom = () => {
    document.title = "Qəbul";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Distributorlar", value: "/expeditors" },
        { name: "Qəbul", value: "/expeditors/handoverfrom", current: true },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Qəbul</h2>
                    <p>
                        Qəbul sənədi, distributora (ekspediterə) qəbul edilən məhsulları qe yd etmək üçün nəzərdə tutulub. <Button>Qəbul</Button> düyməsini
                        sıxıb, açılan pəncərədə lazım olan xanaları doldurub <SaveButton /> düyməsini sıxmaq lazımdır. <Button>Bağla</Button> düyməsi ilə sənədi
                        bağlayıb əsas səhifəyə keçə bilərsiniz.
                        <br />
                        Nümunədə Komisyon satış ⮞ Qəbul ilə bağlı məlumatların əks olunduğu səhifəyə keçid göstərilib.
                    </p>
                    <img src="/images/expeditors/handoverfrom.gif" alt="Qəbul" />
                </article>
            </div>
        </div>
    );
};
